import { createFileRoute } from '@tanstack/react-router';
import IndexPage from '@pages/-[lang]';

export const Route = createFileRoute('/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <IndexPage />;
}
